import MyAltQuotesPanel from "./MyAltQuotesPanel";

export default MyAltQuotesPanel;
